// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* TAG STATUS */\n/* VIEW */\n.color-square[data-v-1c057a8f] {\n  height: 18px;\n  width: 18px;\n  margin-right: 11px;\n  border-radius: 4px;\n}\n.color-circle[data-v-1c057a8f] {\n  height: 18px;\n  width: 18px;\n  margin-right: 11px;\n  border-radius: 50%;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
